/**
 * Process Steps change color on hover
 */
const handleProcessSteps = (element = '.process-step') => {
	$(element).on('mouseover', function() {
		const $this = $(this);
		const $parent = $this.closest('.section-made__content');
		const currentColor = $this.css('color');

		if (! $this.hasClass('is-current')) {
			$parent
				.css('background-color', currentColor);

			$this
				.addClass('is-current');

			$this
				.closest('.process__item')
				.siblings()
				.find('.process-step')
				.removeClass('is-current');
		}
	});
};

handleProcessSteps();
